export default {
  'menu.dashboard.monitorScreen': 'Monitoring Screen',
};
